import React from 'react';

const Settings = () => {
  return (
    <div style={{ padding: '40px', color: '#1a237e' }}>
      <h2>Settings</h2>
      <p>This is the admin settings page. Add your settings options here.</p>
    </div>
  );
};

export default Settings; 